import { isDynamicPersistedTabContent } from 'apiConnector/tabs/tabs.model';
import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import { filter, mergeMap } from 'rxjs/operators';
import { dynamicTabReloadedThunk } from 'state/dynamic/dynamicForm.thunks';
import type { EpicWithThunk } from 'state/state.common';

export function fillTabContentInNewDynamicScreenEpic(): EpicWithThunk {
  return (action$, _state$) =>
    action$.pipe(
      ofType('WORKSPACE_TAB_CONTENT_FETCHED'),
      filter(({ tabContent }) => isDynamicPersistedTabContent(tabContent)),
      mergeMap(({ tabId, tabContent }) => {
        if (!isDynamicPersistedTabContent(tabContent)) {
          return EMPTY;
        }
        return of(dynamicTabReloadedThunk(tabId, tabContent));
      }),
    );
}
